import { useEffect, useState } from "react";
import ReactDom from "react-dom";
import { useDispatch } from "react-redux";
import { appLevelSliceActions } from "../../../store/AppLevelApi/AppLevelSlice";

export const Error = ({ msg }) => {
  // error handler component
  const [statusMessage, setStatusMessage] = useState("top-0");
  const dispatch = useDispatch();
  useEffect(() => {
    setTimeout(() => {
      setStatusMessage("-top-96");
      // dispatch(appLevelSliceActions.setError({ msg: "", isError: false }));
    }, 2000);
  }, [dispatch]);

  const errorCode = (
    <p
      className={`fixed ${statusMessage} z-50 transition ease-in-out duration-150  bg-red w-11/12 left-[4%]  rounded text-center py-3 text-bgwhite`}
    >
      {msg}
    </p>
  );
  //portal use to transfer code to html direct elements
  return ReactDom.createPortal(
    errorCode,
    document.querySelector("#error-message")
  );
};

export const Success = ({ msg }) => {
  const dispatch = useDispatch();
  // success handler component
  const [statusMessage, setStatusMessage] = useState("top-0");
  useEffect(() => {
    setTimeout(() => {
      setStatusMessage("-top-96");
      // dispatch(appLevelSliceActions.setIsSuccess(false));
    }, 2000);
  }, [dispatch]);

  const errorCode = (
    <p
      className={`fixed ${statusMessage} transition ease-in-out delay-1000  bg-textgreen w-11/12 left-[4%] z-40  rounded text-center py-3 text-bgwhite`}
    >
      {msg}
    </p>
  );
  //portal use to transfer code to html direct elements
  return ReactDom.createPortal(
    errorCode,
    document.querySelector("#error-message")
  );
};
